/**
 * Site Configuration
 * Centralized configuration for site name, domain, and metadata
 */

export const SITE_CONFIG = {
  // Site Information
  name: 'KoolMind',
  nameUppercase: 'KOOLMIND',
  domain: 'https://koolmind.in/',
  
  // Site Metadata
  tagline: 'Your Responsible Technology Partner',
  description: 'KoolMind Technolab is the one-stop solution for all kinds of Mobile Apps, Web Apps & Software Development services.',
  
  // Default Title
  defaultTitle: 'Mobile App Development Company in Gujarat',
  
  // Social Media Links
  social: {
    facebook: 'https://www.facebook.com/koolmindtech',
    youtube: 'https://www.youtube.com/@koolmindtechnolab',
    instagram: 'https://www.instagram.com/koolmindtechnolab/',
    twitter: 'https://x.com/koolmindtech',
    linkedin: 'https://www.linkedin.com/company/koolmind/mycompany/',
    clutch: 'https://clutch.co/profile/koolmind-technolab-llp'
  },
  
  // Copyright Year
  copyrightYear: new Date().getFullYear()
};

// Helper function to get full site title
export const getSiteTitle = (pageTitle = '') => {
  if (pageTitle) {
    return `${pageTitle} | ${SITE_CONFIG.name}`;
  }
  return SITE_CONFIG.defaultTitle;
};

// Helper function to get copyright text
export const getCopyrightText = () => {
  return `ALL RIGHTS RESERVED ©${SITE_CONFIG.copyrightYear} ${SITE_CONFIG.nameUppercase}`;
};

export default SITE_CONFIG;

